module.exports = __webpack_public_path__ + "img/alentour1.68ff5402.jpg";